export enum Label {
  DP2 = 'DP 2.0',
  MasterSearch = 'Master Search',
  Datum = 'Datum',
  DPNF = 'DPNF',
  Update = 'Update',
  WorkHistory = 'Work History',
  DP3 = 'DP 3.0',
  AccountSettings = 'Account Settings',
  FindDetails = 'Find Details',
  MergeFC = 'Merge FC',
  AssignedList = 'Assigned List',
  NotFoundList = 'Not Found List',
}

export enum Permissions {
  CanPrintDatum = 'can_print_datum',
  CanMigrateDatum = 'can_migrate_phil_datum',
  CanMarkNotFound = 'can_mark_notfound',
  DefaultRW = 'default_rw',
  CanMarkOtherCountry = 'can_mark_other_country',
  CanMarkEntity = 'can_mark_entity',
  CanExportToExcel = 'can_export_to_excel',
  CanAccessContactNo = 'can_access_contact_no',
  CanViewActiveDatum = 'can_view_active_datum',
  CanViewinactiveDatum = 'can_view_inactive_datum',
  CanSeeUserWiseRejectedDatum = 'can_access_rejection_details',
  CanSeeOtherFWDPNF = 'can_view_others_fw_dpnf_list',
  CanRenameWishlist = 'can_rename_others_wishlist',
  CanDeleteWishlist = 'can_delete_others_wishlist',
  CanDeleteWishlistItem = 'can_delete_others_wishlist_item',
  SuReview = 'suu_fw_update_review',
  ResetUpdatedData = 'review_updated_data_reset',
  SUUpdatedData = 'review_updated_data_mark_for_final_approve',
  RejectUpdatedData = 'review_updated_data_reject',
  ApproveUpdatedData = 'review_updated_data_approve',
  CanMarkDefaulterInactive = 'can_mark_defaulter_inactive',
  CanUpdateDefaulter = 'can_update_defaulter_info',
  CanMarkReach = 'can_mark_reach'
}

export enum PermissionsKey {
  AppIcon = 'appIcon',
  AppRoute = 'appRoute',
  Country = 'country',
  District = 'district',
  State = 'state',
  Icon = 'icon',
  IconActive = 'iconActive',
  LabelName = 'labelName',
  Level = 'level',
  Permission = 'permission',
  Subview = 'subview',
  ViewName = 'viewName',
  ViewType = 'viewType',
  WebRoute = 'webRoute',
}
